<script>
  import Modal from 'svelte-simple-modal';
  import LockedButton from '../button/LockedButton.svelte';
  export let forType = '';
</script>

<Modal
  unstyled={true}
  closeButton={false}
  classContent="relative overflow-auto"
  classWindowWrap="relative m-2 max-h-full"
  classWindow="relative w-full max-h-full my-2 mx-auto rounded-xl shadow-md bg-white max-w-xl"
  classBg="fixed top-0 left-0 w-screen h-screen flex flex-col justify-center bg-black bg-opacity-20 z-40"
>
  <!-- Lock Component Here -->
  <LockedButton {forType} />
</Modal>
